import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { PropertyType } from '@modules/projects/shared/enums/property-type.enum';
import { SharedModule } from '@shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'project-property-type-cell',
  templateUrl: './project-property-type-cell.component.html',
  styleUrls: ['./project-property-type-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule, TranslateModule]
})
export class ProjectPropertyTypeCellComponent implements ListCustomCell {
  PropertyType = PropertyType;

  @ViewChild('template') template;
}
